module.exports = __webpack_public_path__ + "img/Frame783@3x.8d659709.png";